import { render, staticRenderFns } from "./FollowProjectButton.vue?vue&type=template&id=bb77533c"
import script from "./FollowProjectButton.vue?vue&type=script&lang=js"
export * from "./FollowProjectButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports